/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface HubUserResponse {
  data: {
    data: any;
    [key: string]: any;
  };
}

export const hubUsersActions = {
  getHubUsers,
};

// Ecosystem (community hub) users — the people who register/login on the hub.
// Uses the existing backend endpoint GET /api/v1/users (unchanged).
function getHubUsers(): Promise<any> {
  return services.get<HubUserResponse>(`/users?limit=200`).then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    }
    console.log('error in actions get hub users');
    return Promise.reject('Error fetching hub users');
  });
}
